import React from "react";

import { Select } from "@mantine/core";

import { Percentiles } from "lib/frontend/benchmarking/types";

import { useSelectedPercentile } from "./SelectedPercentileProvider";

interface PercentileSelectorProps {
  suppressLabel?: boolean;
}

export function PercentileSelector({
  suppressLabel = false,
}: PercentileSelectorProps): JSX.Element {
  const percentilesArray = Object.values(Percentiles);

  const { selectedPercentile, setSelectedPercentile } = useSelectedPercentile();

  return (
    <Select
      label={suppressLabel ? undefined : "Show data at:"}
      size="sm"
      transitionProps={{ timingFunction: "linear" }}
      value={selectedPercentile}
      w={170}
      withinPortal
      styles={{
        root: {
          textAlign: "center",
        },
        label: {
          fontSize: 12,
          fontWeight: 100,
          color: "#6c757d",
        },
      }}
      data={percentilesArray.map((value) => ({
        value,
        label: `${value}th Percentile`,
      }))}
      // @ts-expect-error TS2322
      onChange={(v: Percentiles) => {
        if (v) {
          setSelectedPercentile(v);
        }
      }}
    />
  );
}
